import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import './About.scss';
import { motion, AnimatePresence } from 'framer-motion';
import {
  fadeinTop,
  pageTransitions,
  fadeinslow,
  fadeinfast,
} from '../../animations';
import { useInView, InView } from 'react-intersection-observer';

import { DataContext } from '../../Contexts/DataContext';

import facebook from '../../Assets/Icons/facebook.png';
import whatsapp from '../../Assets/Icons/whatsapp.png';
import linkedin from '../../Assets/Icons/linkedin.png';
import instagram from '../../Assets/Icons/instagram.png';
import github from '../../Assets/Icons/github.png';

const About = (props) => {
  const { majorLinks } = useContext(DataContext);

  const [top, setTop] = useState(0);
  const handleScroll = (e) => {
    setTop(e.target.scrollTop);
  };

  // useEffect(() => {
  //   let element = document.getElementsByClassName('Scrollable')[0];
  //   element.addEventListener('scroll', handleScroll);
  //   return () => element.removeEventListener('scroll', handleScroll);
  // }, []);

  useEffect(() => {
    if (top > 170) props.setDarkenNavbar(true);
    else props.setDarkenNavbar(false);
  }, [top]);

  return (
    <motion.div
      className="About_Page "
      variants={pageTransitions}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div
        className="About_Page__page-content Scrollable"
        onScroll={handleScroll}
      >
        <motion.div
          className="About_Page__page-content__Title"
          variants={fadeinslow}
          initial="hidden"
          animate="visible"
        >
          <div className="About_Page__page-content__Title-heading">ABOUT</div>

          <div className="About_Page__page-content__Title-details">
            Web Developer | Student | Competitive Programmer
          </div>
        </motion.div>

        <motion.div
          className="About_Page__page-content__Info"
          variants={fadeinfast}
          initial="hidden"
          animate="visible"
        >
          Hello I'm a Web Developer and a Competitive Programmer with an
          effective problem solving mindset and a lifelong passion for Software
          development and technology, I'm currently pursuing BTech CSIT in
          University of Engineering and Management, Kolkata.
        </motion.div>
        <motion.div
          className="About_Page__page-content__Info"
          variants={fadeinfast}
          initial="hidden"
          animate="visible"
        >
          I have worked on projects based on the web using latest technologies
          heading towards the market. I have also gained real life experience on
          my domain from my full time internship. I also indulge myself in
          competitive programming thus sharpening my problem solving skills to
          apply in real life situations for quick and optimised solutions. I
          love to find myself indulged in new ideas and create different and
          unique projects and optimize it in all possible ways to make it work
          in the most ideal way.
        </motion.div>
        <InView threshold={0.7}>
          {({ inView, ref, entry }) => (
            <motion.section
              ref={ref}
              className="About_Page__page-content__Download-Resume margin-top-big "
              variants={fadeinfast}
              initial="hidden"
              animate={inView ? 'visible' : ''}
            >
              <div>
                <a
                  style={{ color: 'white' }}
                  href={majorLinks['resume'] ? majorLinks['resume'].link : ''}
                >
                  Download Resume
                </a>
              </div>
            </motion.section>
          )}
        </InView>

        <InView threshold={0.7}>
          {({ inView, ref, entry }) => (
            <motion.section
              className="About_Page__page-content__Social-media margin-top-small"
              ref={ref}
              variants={fadeinfast}
              initial="hidden"
              animate={inView ? 'visible' : ''}
            >
              <a href="https://www.facebook.com/ankur.saha.3591">
                <img src={facebook} className="hover-glow" />
              </a>
              <a href="https://www.linkedin.com/in/ankur-saha/">
                <img src={linkedin} className="hover-glow" />
              </a>
              <a href="https://github.com/Excalibur79">
                <img src={github} className="hover-glow" />
              </a>
              <a href="https://www.instagram.com/_a_n_k_u_r_saha/">
                <img src={instagram} className="hover-glow" />
              </a>
            </motion.section>
          )}
        </InView>
      </div>
    </motion.div>
  );
};

export default About;
